<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="姓名"
                ><a-input
                  allowClear
                  v-model="queryParam.realName"
                  placeholder="姓名"
              /></a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-model-item label="手机号码"
                ><a-input
                  allowClear
                  v-model="queryParam.mobile"
                  placeholder="手机号码"
              /></a-form-model-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-model-item label="小区">
                  <a-input
                    allowClear
                    ref="cn"
                    v-model="queryParam.communityName"
                    @change="onChange"
                    @click="onSearch"
                    placeholder="请选择小区"
                  />
                </a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="楼号"
                  ><a-input
                    allowClear
                    v-model="queryParam.buildingNo"
                    placeholder="楼号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="单元号"
                  ><a-input
                    allowClear
                    v-model="queryParam.unitNo"
                    placeholder="单元号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="门牌号"
                  ><a-input
                    allowClear
                    v-model="queryParam.houseNum"
                    placeholder="门牌号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="房号"
                  ><a-input
                    allowClear
                    v-model="queryParam.roomNum"
                    placeholder="房号"
                /></a-form-model-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="租约状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="L">失效</a-select-option>
                    <a-select-option value="R">待签约</a-select-option>
                    <a-select-option value="B">签约中</a-select-option>
                    <a-select-option value="I">租约正常</a-select-option>
                    <a-select-option value="S">租约到期</a-select-option>
                    <a-select-option value="X">租约取消</a-select-option>
                    <a-select-option value="Z">转租</a-select-option>
                    <a-select-option value="V">违约</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="审核状态">
                  <a-select
                    v-model="queryParam.checkSta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="R">待审核</a-select-option>
                    <a-select-option value="C">管家已审核</a-select-option>
                    <a-select-option value="S"
                      >商户(房东)已审核</a-select-option
                    >
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-model-item label="合同编号"
                  ><a-input
                    allowClear
                    v-model="queryParam.contractNo"
                    placeholder="合同编号"
                /></a-form-model-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="类型">
                  <a-select
                    v-model="queryParam.t"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="1">本月到期</a-select-option>
                    <a-select-option value="2">本月交租</a-select-option>
                    <a-select-option value="3">到期周期</a-select-option>
                    <a-select-option value="4">交租周期</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24" v-if="queryParam.t">
                <a-form-model-item label="周期">
                  <a-select
                    placeholder="请选择"
                    v-if="queryParam.t < 3"
                    v-model="queryParam.m"
                  >
                    <a-select-option value="0">全部</a-select-option>
                    <a-select-option value="01">1月</a-select-option>
                    <a-select-option value="02">2月</a-select-option>
                    <a-select-option value="03">3月</a-select-option>
                    <a-select-option value="04">4月</a-select-option>
                    <a-select-option value="05">5月</a-select-option>
                    <a-select-option value="06">6月</a-select-option>
                    <a-select-option value="07">7月</a-select-option>
                    <a-select-option value="08">8月</a-select-option>
                    <a-select-option value="09">9月</a-select-option>
                    <a-select-option value="10">10月</a-select-option>
                    <a-select-option value="11">11月</a-select-option>
                    <a-select-option value="12">12月</a-select-option>
                  </a-select>
                  <a-range-picker
                    v-model="queryParam.dateRang"
                    v-if="queryParam.t >= 3"
                  />
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <!-- <a-button type="primary" icon="plus" style="margin-left: 8px"
                              >创建租约</a-button
                            > -->
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :scroll="{ x: 2450 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="checkSta" slot-scope="text">
          <template>
            <a-tag class="render-tag" :color="text == 'R' ? '#f50' : '#87d068'"
              >{{ text == "R" ? "待审核" : "已审核" }}({{ text }})</a-tag
            >
          </template>
        </span>
        <span slot="sta" slot-scope="text">
          <template>
            <a-tag class="render-tag" v-if="text == 'L'" color="grey"
              >失效</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'R'" color="#737373"
              >待签约</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'B'" color="#2a7630"
              >签约中</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'I'" color="#87d068"
              >租约正常</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'S'" color="#ff6666"
              >租约到期</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'X'" color="orange"
              >租约取消</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'Z'" color="#108ee9"
              >转租</a-tag
            >
            <a-tag class="render-tag" v-if="text == 'V'" color="red"
              >违约</a-tag
            >
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              v-if="record.checkSta == 'R' && record.sta == 'R'"
              @click="sure(record)"
              >确认租约</a
            >
            <a-popconfirm
              v-if="record.sta == 'R' && record.checkSta != 'R'"
              title="确认取消租约吗？"
              @confirm="cancel(record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">取消租约</a>
            </a-popconfirm>
            <a-popconfirm
              v-if="record.sta == 'B' && record.checkSta == 'S'"
              title="确认签约失败吗？"
              @confirm="contractFail(record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">签约失败</a>
            </a-popconfirm>
            <a
              class="a-action"
              v-if="
                record.contractNo && record.checkSta != 'R' && record.sta == 'I'
              "
              @click="createContract(record)"
            >
              创建租约
            </a>
            <a
              class="a-action"
              v-if="
                record.contractNo &&
                  record.checkSta != 'R' &&
                  (record.sta == 'I' ||
                    record.sta == 'S' ||
                    record.sta == 'Z' ||
                    record.sta == 'V')
              "
              @click="getContractImg(record)"
            >
              查看合同
            </a>
            <a
              class="a-action"
              v-if="
                record.contractNo &&
                  record.checkSta != 'R' &&
                  (record.sta == 'I' ||
                    record.sta == 'S' ||
                    record.sta == 'Z' ||
                    record.sta == 'V')
              "
              @click="downContractPdf(record)"
            >
              下载
            </a>
            <a-popconfirm
                v-if="record.sta == 'B'"
                :title="`确认给【${record.mobile}】重发短信吗？`"
                @confirm="retrySendSms(record)"
                okText="确认"
                cancelText="取消"
            >
              <a class="a-action">重发短信</a>
            </a-popconfirm>
            <a class="a-action" style="display: block;" v-if="record.sta == 'B'" @click="lookSmsInfo(record)">查看短信内容</a>
            <a-popconfirm
              v-if="
                record.contractNo && record.checkSta != 'R' && record.sta == 'Z'
              "
              title="确认转租成功吗？"
              @confirm="sublet(record, 'success')"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">转租成功</a>
            </a-popconfirm>

            <a-popconfirm
              v-if="
                record.contractNo && record.checkSta != 'R' && record.sta == 'Z'
              "
              title="确认取消转租吗？"
              @confirm="sublet(record, 'cancel')"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">取消转租</a>
            </a-popconfirm>
            <a-popconfirm
              v-if="
                record.contractNo && record.checkSta != 'R' && record.sta == 'Z'
              "
              title="确认转租到期吗？"
              @confirm="finish(record)"
              okText="确认"
              cancelText="取消"
            >
              <a class="a-action">转租到期</a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
    </a-card>
    <!-- 查看合同 -->
    <a-modal
      title="查看合同"
      v-model="modal.visible"
      width="50%"
      :height="700"
      :footer="null"
      @cancel="hideModal"
    >
      <div style="height: 100%;width: 100%;">
        <iframe
          :src="modal.previewUrl"
          hight="100%"
          ref="frame"
          width="100%"
          frameborder="0"
          scrolling="auto"
          onload="this.height=700"
        ></iframe>
      </div>
    </a-modal>
    <!-- 确认租约 -->
    <edit-lease-form
      ref="editLeaseForm"
      @success="$refs.table.refresh(true)"
    ></edit-lease-form>
    <!-- 创建租约 -->
    <create-lease-form
      ref="createLeaseForm"
      @success="$refs.table.refresh(true)"
    ></create-lease-form>
    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>
  </page-view>
</template>
<script>
import { PageView } from "@/layouts";
import EditLeaseForm from "./form/EditLeaseForm.vue";
import CreateLeaseForm from "./form/CreateLeaseForm.vue";
import { STable } from "@/components";
import CommunityModal from "../house/stepForm/CommunityModal.vue";
export default {
  components: {
    PageView,
    EditLeaseForm,
    CreateLeaseForm,
    STable,
    CommunityModal
  },
  name: "LeaseList",
  data() {
    return {
      userInfo: {},
      advanced: false,
      queryParam: {
        t: undefined,
        m: undefined,
        communityCode: "",
        communityName: ""
      },
      modal: {
        visible: false,
        imageList: [],
        previewUrl: ""
      },
      // 表头
      columns: [
        {
          title: "姓名",
          dataIndex: "realName",
          fixed: "left"
        },
        {
          title: "性别",
          dataIndex: "sex",
          fixed: "left"
        },
        {
          title: "手机号",
          dataIndex: "hideMobile",
          fixed: "left"
        },
        {
          title: "身份证号",
          dataIndex: "hideIdCardNo",
          fixed: "left"
        },
        {
          title: "房号",
          dataIndex: "no",
          width: 120
        },
        {
          title: "租约状态",
          dataIndex: "sta",
          width: 90,
          scopedSlots: { customRender: "sta" }
        },
        {
          title: "审核状态",
          dataIndex: "checkSta",
          width: 90,
          scopedSlots: { customRender: "checkSta" }
        },
        {
          title: "类型",
          dataIndex: "rentTypeName",
          width: 80
        },
        {
          title: "月租金(元)",
          dataIndex: "monthRent",
          width: 100
        },
        {
          title: "押金",
          dataIndex: "deposit",
          width: 100
        },
        {
          title: "付款方式",
          dataIndex: "payWayName",
          width: 100
        },
        {
          title: "开始时间",
          dataIndex: "startTime",
          width: 120
        },
        {
          title: "下次交租",
          dataIndex: "nextTime",
          width: 120
        },
        {
          title: "结束时间",
          dataIndex: "finishTime",
          width: 120
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          width: 220
        },
        {
          title: "签订时间",
          dataIndex: "contractTime",
          width: 200
        },
        {
          title: "修改人",
          dataIndex: "modifyUser"
        },
        {
          title: "修改时间",
          dataIndex: "modifyDatetime",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          width: 220,
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let searchParam = Object.assign(parameter, this.queryParam);
        //当前时间
        let date = new Date();
        let year = date.getFullYear().toString();
        let str = "";
        if (this.queryParam.m != "0") {
          str = year + "-" + this.queryParam.m;
        }
        if (this.queryParam.t == 2) {
          //本月交租
          if (this.queryParam.m > 0) {
            searchParam.nextTime = str + "-01 00:00:00";
            searchParam.nextTimeEnd = str + "-31 23:59:59";
          }
        } else if (this.queryParam.t == 1) {
          //本月到期
          if (this.queryParam.m > 0) {
            searchParam.finishTime = str + "-01 00:00:00";
            searchParam.finishTimeEnd = str + "-31 23:59:59";
          }
        } else if (this.queryParam.t == 3) {
          //到期周期
          if (this.queryParam.dateRang.length > 0) {
            let start = this.queryParam.dateRang[0].format("YYYY-MM-DD");
            let end = this.queryParam.dateRang[1].format("YYYY-MM-DD");
            searchParam.finishTime = start + " 00:00:00";
            searchParam.finishTimeEnd = end + " 23:59:59";
          }
        } else if (this.queryParam.t == 4) {
          //交租周期
          if (this.queryParam.dateRang.length > 0) {
            let start = this.queryParam.dateRang[0].format("YYYY-MM-DD");
            let end = this.queryParam.dateRang[1].format("YYYY-MM-DD");
            searchParam.nextTime = start + " 00:00:00";
            searchParam.nextTimeEnd = end + " 23:59:59";
          }
        }
        searchParam.sort = "hul.id:desc";
        return this.$http.roomBksApi
          .pageHouseUserLease(searchParam)
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
    this.queryParam.merchantNo = this.userInfo.merchantNo;
    if (this.userInfo.userType == "2") {
      this.queryParam.keeperUserNo = this.userInfo.userNo;
    }
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam = {};
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
      this.queryParam.merchantNo = this.userInfo.merchantNo;
      if (this.userInfo.userType == "2") {
        this.queryParam.keeperUserNo = this.userInfo.userNo;
      }
    },
    hideModal() {
      this.modal.visible = false;
      this.modal.previewUrl = "";
    },
    /**
     * 获取合同图片
     * @param {Object} item
     */
    getContractImg(item) {
      this.modal.visible = true;
      this.showIframe;
      let param = {};
      param.contractId = item.contractNo;
      param.account = this.userInfo.merchantNo;
      param.userType = "M";
      this.$http.roomBksApi.getContractPreviewURL(param).then(res => {
        if (res && res.result == 0) {
          this.modal.previewUrl = res.resultObject;
        }
      });
    },
    /**
     * 创建租约
     * @param {Object} item
     */
    createContract(item) {
      this.$refs.createLeaseForm.show(item);
    },
    /**
     * 下载合同
     * @param {Object} item
     */
    downContractPdf(item) {
      let param = {};
      param.contractId = item.contractNo;
      param.account = this.userInfo.merchantNo;
      param.userType = "M";
      this.$http.roomBksApi.downloadContract(param, item.contractNo + ".pdf");
    },
    /**
     * 重发短信
     * @param item
     */
    retrySendSms(item){
      let param = {};
      param.leaseNo = item.leaseNo;
      this.$http.roomBksApi.retrySendSignSms(param).then(res =>{
        if (res.result == 0) {
          this.$message.success(res.msg);
        }
      });
    },
    lookSmsInfo(item){
      let param = {};
      param.leaseNo = item.leaseNo;
      this.$http.roomBksApi.findSendSmsByLeaseNo(param).then(res =>{
        if (res.result == 0) {
          let info = res.resultObject;
          this.$info({content:info.content});
        }
      });
    },
    sure(item) {
      this.$refs.editLeaseForm.show(item);
    },
    cancel(item) {
      let param = {};
      param.leaseNo = item.leaseNo;
      param.sta = "X"; //取消租约
      param.checkSta = this.userInfo.userType == "2" ? "C" : "S";
      param.businessType = "cancel";
      this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
        if (res.result == 0) {
          this.$message.success("租约取消成功");
          this.$refs.table.refresh(true);
        }
      });
    },
    contractFail(item) {
      let param = {};
      param.leaseNo = item.leaseNo;
      param.sta = "F"; //签约失败
      param.checkSta = this.userInfo.userType == "2" ? "C" : "S";
      param.businessType = "fail";
      this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
        if (res.result == 0) {
          this.$message.success("租约取消成功");
          this.$refs.table.refresh(true);
        }
      });
    },
    // sign(record) {
    //   let param = {};
    //   param.account = this.userInfo.merchantNo;
    //   param.userType = "M";
    //   param.leaseNo = record.leaseNo;
    //   this.$http.roomBksApi.findSignContractUrl(param).then(res => {
    //     if (res && res.result == 0) {
    //       window.open(res.resultObject, "_blank");
    //     }
    //   });
    // },
    sublet(record, flag) {
      let param = {};
      param.id = record.id;
      param.leaseNo = record.leaseNo;
      param.subletFlag = flag;
      param.businessType = "modify";
      this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
        if (res.result == 0) {
          this.$message.success(flag == "cancel" ? "取消转租成功" : "转租成功");
          this.$refs.table.refresh(true);
        }
      });
    },
    finish(record) {
      let param = {};
      param.id = record.id;
      param.leaseNo = record.leaseNo;
      param.sta = "S";
      param.businessType = "modify";
      this.$http.roomBksApi.modifyHouseUserLease(param).then(res => {
        if (res.result == 0) {
          this.$message.success("处理成功");
          this.$refs.table.refresh(true);
        }
      });
    },
    onChange(evt) {
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      this.queryParam.communityCode = item.communityCode;
      this.queryParam.communityName = item.communityName;
      this.$refs.cn.focus();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-card-actions {
  text-align: right;
}
/deep/ .ant-card-actions > li {
  float: none;
  width: auto !important;
  display: inline-block;
  margin-right: 10px;
}
.ant-carousel /deep/ .slick-dots {
  height: auto;
}
.ant-carousel /deep/ .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 90%;
}
.ant-carousel /deep/ .slick-thumb {
  // bottom: -45px;
}
.ant-carousel /deep/ .slick-thumb li {
  width: 60px;
  height: 45px;
}
.ant-carousel /deep/ .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}
.ant-carousel /deep/ .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

.spin {
  text-align: center;
  // background: rgba(0, 0, 0, 0.05);
  // border-radius: 4px;
  // margin-bottom: 20px;
  // padding: 30px 50px;
  margin: 20px auto;
}
.actions {
  button {
    margin-right: 10px;
  }
}
</style>
